// extracted by mini-css-extract-plugin
export default {"card":"C1-z","carouselContainer":"D1-z","carouselContent":"E1-z"};